import React, { useState, useEffect, useContext, useRef } from 'react';
import DatePicker from "react-datepicker";
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import * as Constants from '../Shared/Constants.js'
import CommentsList from '../Shared/CommentsList/CommentsList.js'
import MedboardPdf from '../MedboardPdf/MedboardPdf.jsx';
import { Tags } from '../Shared/Tags.js'
import TaskManager from '../TaskManager/TaskManager.js';
import { EventEmitter } from "events";
import EntityAssociation from "../Shared/EntityAssociation.js";
import { datePopperConfig } from "../Shared/datePopperConfig.js";


const ItemDetailsPane = ({ globalContext }) => {

    const AppContext = globalContext;
    const [isSavingItem, setIsSavingItem] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [visibleDetailsTab, setVisibleDetailsTab] = useState("tasks");

    const [isEditingField, setIsEditingField] = useState({
        title: false,
        description: false,
        responsible: false,
        deadline: false,
    });
    const [errorCurrentItemDeadline, setErrorCurrentItemDeadline] = useState(false);


    const currentItemTitleRef = useRef(null);


    const saveCurrentItem = () => {
        let isValidForm = true;
        let currentItem = AppContext.currentItem;

        AppContext.setErrorCurrentItemTitle(false);
        setErrorCurrentItemDeadline(false);

        if (!validFormField(currentItem.Title, AppContext.setErrorCurrentItemTitle)) isValidForm = false;
        if (!validFormField(currentItem.Deadline, setErrorCurrentItemDeadline)) isValidForm = false;

        if (!isValidForm) return false;

        setIsSavingItem(true);
        setIsShowingSaveMessage(false);
        disableAllItemFormFieldsEdit();

        // Update item remotely and if successful...

        currentItem.Entities = AppContext.linkedObjectsList;

        AppContext.setCurrentItem(currentItem);

        let updateItemURL = AppContext.dataUrl;

        let requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(currentItem)
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    // Update the item in the existing item array
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );
                    AppContext.setData(updatedDataArray);
                    setIsShowingSaveMessage(true);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItem(false);
            });
    };


    const enableItemFormFieldEdit = (field, e) => {
        e.stopPropagation();
        let newObj = { ...isEditingField, [field]: true };
        setIsEditingField(newObj);
    };

    const disableAllItemFormFieldsEdit = () => {
        let newObj = { ...isEditingField };
        for (let prop in newObj) {
            newObj[prop] = false;
        }
        setIsEditingField(newObj);
    };

    const validFormField = (field, errorFunc) => {
        if (field === "" || field == null) {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };

    const displayDescription = (text) => {
        if (text == null || text == "")
            return "";

        text = text.replace(/</g, '&lt;');
        text = text.replace(/\n/g, '<br/>');
        return text;
    };


    const User = ({ value, size }) => {

        let user = AppContext.getUserById(value);

        return (
            <>
                {user ? (
                    <div
                        className={
                            "user-initials-circle " +
                            (size == "small" ? "user-initials-circle-small" : "")
                        }
                        style={{ backgroundColor: user?.IsItMe ? "#0176b9" : "#e7e7e7", color: user?.IsItMe ? "white" : "black" }}
                        title={user?.Name}
                    >
                        {user?.Initials}
                    </div>
                ) : null}
            </>
        );
    };




    return (
        <div id="thisone_1"
            style={{ height: "100vh", overflow: "auto" }}
            className={`slide-pane ${AppContext.isPaneOpen ? "open" : ""}`}
        >
            <div className="content">

                <div style={{ flex: "1" }}>

                    {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? (
                        <>
                            <div>
                                <LoadingSpinnerImage />
                            </div>
                        </>
                    ) : (
                        <>
                            <div style={{ textAlign: "right", marginBottom: "10px" }}>
                                <button className="close-button" onClick={AppContext.closePane}>
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>

                            <h2>{AppContext.singleItemTitle} Details</h2>

                            {/* FORMS FIELDS */}

                            <div style={{ margin: "40px 0px" }}>



                                {/* Form field: Title */}

                                <div className="view-task-field">
                                    {isEditingField.title === false ? (
                                        <>
                                            <span
                                                className={`task-name editable-field-span ${AppContext.errorCurrentItemTitle
                                                    ? "form-field-error"
                                                    : null
                                                    }`}
                                                onClick={(e) => {
                                                    enableItemFormFieldEdit("title", e);
                                                    setTimeout(() => {
                                                        // We need this timeout because the ref for the edit field isn't immediately available
                                                        currentItemTitleRef.current.selectionStart = 0;
                                                        currentItemTitleRef.current.selectionEnd = 0;
                                                    }, 10);
                                                }
                                                }
                                            >
                                                {AppContext.currentItem.Title}
                                                {AppContext.errorCurrentItemTitle && (
                                                    <span className="form-field-error-message">
                                                        The field Title is necessary
                                                    </span>
                                                )}
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            <span>
                                                <input
                                                    ref={currentItemTitleRef}
                                                    style={{ width: "100%" }}
                                                    className="task-name"
                                                    autoFocus
                                                    onBlur={() => {
                                                        disableAllItemFormFieldsEdit();
                                                        validFormField(
                                                            AppContext.currentItem.Title,
                                                            AppContext.setErrorCurrentItemTitle
                                                        );
                                                    }}
                                                    onChange={(e) =>
                                                        AppContext.setCurrentItem({
                                                            ...AppContext.currentItem,
                                                            Title: e.target.value
                                                        })
                                                    }
                                                    value={AppContext.currentItem.Title}
                                                />
                                            </span>
                                        </>
                                    )}
                                </div>




                                {/* Form field: Description */}

                                <div className="view-task-field">

                                    <div className="view-task-field-line">
                                        <div className="view-task-field-title">Description</div>
                                        <div className="view-task-field-value">

                                            {isEditingField.description === false ? (
                                                <>
                                                    <div
                                                        className={`editable-field-span thin-scrollbar`}
                                                        style={{ width: "100%", maxHeight: "300px", overflowY: "auto" }}
                                                        onClick={(e) =>
                                                            enableItemFormFieldEdit("description", e)
                                                        }
                                                    >

                                                        {AppContext.currentItem.Description == "" ?
                                                            <span style={{ color: "#c0c0c0" }}>Add a description</span>
                                                            :
                                                            <div dangerouslySetInnerHTML={{ __html: displayDescription(AppContext.currentItem.Description) }} />
                                                        }
                                                    </div>

                                                </>
                                            ) : (
                                                <>
                                                    <span style={{ width: "100%" }}>
                                                        <textarea
                                                            style={{ width: "100%", height: "150px" }}
                                                            autoFocus
                                                            onBlur={() => {
                                                                disableAllItemFormFieldsEdit();
                                                            }}
                                                            onChange={(e) =>
                                                                AppContext.setCurrentItem({
                                                                    ...AppContext.currentItem,
                                                                    Description: e.target.value
                                                                })
                                                            }
                                                            value={AppContext.currentItem.Description}
                                                        />
                                                    </span>
                                                </>
                                            )}

                                        </div>
                                    </div>

                                </div>







                                    {/* Form field: ResponsiblePerson */}

                                    <div className="view-task-field">
                                        <div className="view-task-field-line">
                                            <div className="view-task-field-title">Responsible</div>
                                            <div className="view-task-field-value">
                                                {isEditingField.responsible === false ? (
                                                    <>
                                                        <div
                                                            className="editable-field-span"
                                                            onClick={(e) =>
                                                                enableItemFormFieldEdit("responsible", e)
                                                            }
                                                        >
                                                            <User value={AppContext.currentItem.ResponsiblePerson} />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span>
                                                            <select
                                                                value={AppContext.currentItem.ResponsiblePerson}
                                                                onBlur={() =>
                                                                    disableAllItemFormFieldsEdit()
                                                                }
                                                                onChange={(e) => {
                                                                    AppContext.setCurrentItem({
                                                                        ...AppContext.currentItem,
                                                                        ResponsiblePerson: e.target.value
                                                                    });
                                                                }}
                                                            >
                                                                {AppContext.users.map((user, index) => (
                                                                    <option key={index} value={user.Id}>
                                                                        {user.Name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </span>
                                                    </>
                                                )}

                                            </div>
                                        </div>
                                    </div>










                                    {/* Form field: Deadline */}

                                    <div className="view-task-field">
                                        <div className="view-task-field-line">
                                            <div className="view-task-field-title">Deadline / Next Collection</div>
                                            <div className="view-task-field-value">
                                                {isEditingField.deadline === false ? (
                                                    <>
                                                        <span
                                                            className={`editable-field-span ${errorCurrentItemDeadline
                                                                ? "form-field-error"
                                                                : null
                                                                }`}
                                                            onClick={(e) =>
                                                                enableItemFormFieldEdit("deadline", e)
                                                            }
                                                        >
                                                            {AppContext.readableDate(AppContext.currentItem.Deadline, true)}
                                                            {errorCurrentItemDeadline && (
                                                                <span className="form-field-error-message">
                                                                    The field Deadline is necessary
                                                                </span>
                                                            )}
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span>
                                                            <DatePicker
                                                                dateFormat="yyyy-MM-dd"
                                                                className={`${errorCurrentItemDeadline ? "form-field-error" : null}`}
                                                                onBlur={() => {
                                                                    disableAllItemFormFieldsEdit();
                                                                    validFormField(
                                                                        AppContext.currentItem.Deadline,
                                                                        setErrorCurrentItemDeadline
                                                                    );
                                                                }}
                                                                selected={AppContext.unformatDate(
                                                                    AppContext.currentItem.Deadline
                                                                )}
                                                                onChange={(date) => {
                                                                    let newObj = {
                                                                        ...AppContext.currentItem,
                                                                        Deadline: AppContext.formatDate(date)
                                                                    };
                                                                    AppContext.setCurrentItem(newObj);
                                                                    validFormField(
                                                                        newObj.Deadline,
                                                                        setErrorCurrentItemDeadline
                                                                    );
                                                                    disableAllItemFormFieldsEdit();
                                                                    }}
                                                                popperPlacement={datePopperConfig.placement}
                                                                popperModifiers={datePopperConfig.modifiers}
                                                            />
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>





                            </div>



                            {/* SRS LIST */}
                            {/* SRS LIST */}
                            {/* SRS LIST */}



                            
                            






                            {/* FORMS BUTTONS */}

                            <div className="action-button-bar">
                                <div className="action-button-bar-left">

                                    <button
                                        className="action-button cancel-button"
                                        onClick={AppContext.closePane}
                                    >
                                        Cancel
                                    </button>

                                </div>



                                <div className="action-button-bar-center">

                                </div>



                                <div className="action-button-bar-right">
                                    {!isSavingItem ? (
                                        <>
                                            <button
                                                className="action-button save-button"
                                                onClick={saveCurrentItem}
                                            >
                                                Save
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <LoadingSpinnerImage />
                                        </>
                                    )}
                                    <span
                                        className={`${isShowingSaveMessage
                                            ? "save-message-shown"
                                            : "save-message-hidden"
                                            }`}
                                        onTransitionEnd={() => setIsShowingSaveMessage(false)}
                                    >
                                        Save successful!
                                    </span>
                                </div>
                            </div>




                        </>
                    )}

                </div>

            </div>
        </div>
    );
};














export default ItemDetailsPane;